module.exports = __webpack_public_path__ + "static/img/merit2.abb250e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/merit2.png
// module id = unAI
// module chunks = 2